"use strict";
/** Προτιμήσεις ειδοποιήσεων ανά κανάλι — αποθηκεύονται στο User.notificationPrefs (JSON). */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOTIFICATION_CHANNEL_LABELS = exports.NOTIFICATION_PREF_LABELS = exports.DEFAULT_NOTIFICATION_PREFERENCES = exports.NOTIFICATION_PREF_CATEGORIES = exports.NOTIFICATION_PREF_CHANNELS = void 0;
exports.parseNotificationPreferences = parseNotificationPreferences;
exports.mergeNotificationPreferences = mergeNotificationPreferences;
exports.isNotificationEnabled = isNotificationEnabled;
exports.NOTIFICATION_PREF_CHANNELS = ['email', 'push', 'inApp'];
exports.NOTIFICATION_PREF_CATEGORIES = [
    'offers',
    'billing',
    'referral',
    'crm',
];
exports.DEFAULT_NOTIFICATION_PREFERENCES = {
    email: {
        offers: true,
        billing: true,
        referral: true,
        crm: false,
    },
    push: {
        offers: false,
        billing: false,
        referral: false,
        crm: true,
    },
    inApp: {
        offers: true,
        billing: true,
        referral: true,
        crm: true,
    },
};
exports.NOTIFICATION_PREF_LABELS = {
    offers: {
        title: 'Προσφορές',
        hint: 'Αποδοχή / απόρριψη προσφοράς από πελάτη',
    },
    billing: {
        title: 'Συνδρομή & δοκιμή',
        hint: 'Πληρωμές, λήξη συνδρομής ή δοκιμής Pro',
    },
    referral: {
        title: 'Επιβράβευση',
        hint: 'Κέρδος credit από σύσταση συναδέλφων',
    },
    crm: {
        title: 'CRM & εργασίες',
        hint: 'Νέες εργασίες, εκπρόθεσμες υπενθυμίσεις (push μόνο mobile)',
    },
};
exports.NOTIFICATION_CHANNEL_LABELS = {
    email: 'Email',
    push: 'Push (κινητό)',
    inApp: 'Εντός εφαρμογής',
};
function channelPrefsFromPartial(partial, defaults) {
    if (!partial || typeof partial !== 'object')
        return { ...defaults };
    const o = partial;
    const out = { ...defaults };
    for (const cat of exports.NOTIFICATION_PREF_CATEGORIES) {
        if (typeof o[cat] === 'boolean')
            out[cat] = o[cat];
    }
    return out;
}
function parseNotificationPreferences(raw) {
    if (!raw || typeof raw !== 'object') {
        return {
            email: { ...exports.DEFAULT_NOTIFICATION_PREFERENCES.email },
            push: { ...exports.DEFAULT_NOTIFICATION_PREFERENCES.push },
            inApp: { ...exports.DEFAULT_NOTIFICATION_PREFERENCES.inApp },
        };
    }
    const o = raw;
    return {
        email: channelPrefsFromPartial(o.email, exports.DEFAULT_NOTIFICATION_PREFERENCES.email),
        push: channelPrefsFromPartial(o.push, exports.DEFAULT_NOTIFICATION_PREFERENCES.push),
        inApp: channelPrefsFromPartial(o.inApp, exports.DEFAULT_NOTIFICATION_PREFERENCES.inApp),
    };
}
function mergeNotificationPreferences(current, patch) {
    const mergeChannel = (base, delta) => {
        if (!delta)
            return { ...base };
        const next = { ...base };
        for (const cat of exports.NOTIFICATION_PREF_CATEGORIES) {
            if (typeof delta[cat] === 'boolean')
                next[cat] = delta[cat];
        }
        return next;
    };
    return {
        email: mergeChannel(current.email, patch.email),
        push: mergeChannel(current.push, patch.push),
        inApp: mergeChannel(current.inApp, patch.inApp),
    };
}
function isNotificationEnabled(prefs, channel, category) {
    return prefs[channel][category];
}
